import { SaveOutlined } from '@ant-design/icons';
import ModalTextForm from '@app/components/modal/ModalTextForm';
import { Button, Checkbox, Col, DatePicker, Form, Input, Row, Tabs } from 'antd';
import viVN from 'antd/lib/date-picker/locale/vi_VN';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ContentHeader } from "../../components";
import { Links } from "../../helpers/Links";
import { dateCommon, validateMessages } from "../../helpers/common";
import { ChiTietNgayNghi } from "../../models/ngaynghi/NgayNghi";
import { layChiTiet, luuNgayNghi, xoaNgayNghi } from "../../services/ngaynghi";
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import LoaiNgayNghiSelectBox from '../utils/LoaiNgayNghiSelectBox';

const ChiTietNgayLe = () => {
    const params = new URLSearchParams(window.location.search)
    let id = params.get('id') || '0';
    let navigate = useNavigate();
    const { TextArea } = Input;
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [themMoi, setThemMoi] = useState(true);
    const [title, setTitle] = useState("Thêm mới ngày nghỉ/làm bù");
    const [openModalLuu, setOpenModalLuu] = useState(false);
    const [openModalXoa, setOpenModalXoa] = useState(false);
    const [isLapHangNam, setIsLapHangNam] = useState(false);
    const [data, setData] = useState<ChiTietNgayNghi>(new ChiTietNgayNghi);
    const dispatch = useDispatch();
    const [rowIndex, setRowIndex] = useState(-1);

    const submitLuu = async (value: any) => {
        try {
            setRowIndex(-1);
            dispatch(showLoadingScreen());
            await luuNgayNghi(value);
            setOpenModalLuu(false);
            dispatch(showLoadingScreen());
            toast.success(themMoi ? 'Tạo mới ngày nghỉ/làm bù thành công!' : 'Cập nhật ngày nghỉ/làm bù thành công!');
            dispatch(hideLoadingScreen());
            navigate(Links.NgayNghi.DanhSach);
        }
        catch (error: any) {
            setLoading(false);
            dispatch(hideLoadingScreen());
            setOpenModalLuu(false);
            toast.error(error.message || "Vui lòng thử lại");
        };
    };
    const xoa = async () => {
        try {
            setLoading(true);
            await xoaNgayNghi(parseInt(id));
            setLoading(false);
            setOpenModalXoa(false);
            toast.success('Xóa ngày nghỉ/làm bù thành công');
            navigate(Links.NgayNghi.DanhSach);
        }
        catch (error: any) {
            setLoading(false);
            toast.error('Xóa ngày nghỉ/làm bù không thành công! Vui lòng thử lại.');
        };
    };

    const layCT = async (id: number) => {
        setLoading(true);
        dispatch(showLoadingScreen());
        try {
            let data = await layChiTiet(id);
            setData(data);
            if (data.id > 0) {
                form.setFieldsValue({
                    id: data?.id,
                    lyDo: data?.lyDo,
                    heSo: data?.heSo,
                    idLoaiNgayNghi: data?.idLoaiNgayNghi,
                    ghiChu: data?.ghiChu,
                    isLapHangNam: data?.lapHangNam,
                    tuNgay: data?.tuNgay ? dayjs(dateCommon.formatDate(data.tuNgay), "DD/MM/YYYY") : null,
                    denNgay: data?.denNgay ? dayjs(dateCommon.formatDate(data?.denNgay), "DD/MM/YYYY") : null
                })
                setIsLapHangNam(Boolean(data.lapHangNam));
                setTitle("Chi tiết ngày nghỉ");
                setThemMoi(false);
            }
            setLoading(false);
        } catch (error: any) {
            toast.error("Ngày nghỉ không tồn tại!");
            setLoading(false);
        }
        dispatch(hideLoadingScreen());
    }

    const disableDenNgay = (current: any) => {
        const tuNgayValue = dayjs(form.getFieldValue('tuNgay'));
        const denNgayValue = dayjs(form.getFieldValue('denNgay'));

        if (tuNgayValue > denNgayValue) {
            form.setFieldValue('denNgay', null);
        }

        return current && current < tuNgayValue;
    }

    const onFinish = (values: any) => {
        var saveData: ChiTietNgayNghi = {
            "id": parseInt(id),
            "ghiChu": values.ghiChu || "",
            "lyDo": values.lyDo || "",
            "heSo": values.heSo || null,
            "idLoaiNgayNghi": values.idLoaiNgayNghi || "",
            "lapHangNam": isLapHangNam ? 1: 0,
            "tuNgay": values.tuNgay,
            "denNgay": values.denNgay,
        };
        setData(saveData);
        setOpenModalLuu(true)
    };

    useEffect(() => {
        setLoading(true);
        if (parseInt(id) > 0) {
            layCT(parseInt(id));
        }
        setLoading(false);
    }, []);

    return (
        <>
            <ContentHeader title={title} />
            {
                openModalXoa && <ModalTextForm show={openModalXoa}
                title="Xoá lớp đào tạo"
                handleClose={() => setOpenModalXoa(false)}
                handleSave={() => xoa()}>
                Bạn có đồng ý xóa ngày nghỉ này không?
                </ModalTextForm>
            }
            {
                openModalLuu && <ModalTextForm show={openModalLuu}
                    title={!themMoi ? "Cập nhật ngày nghỉ" : "Thêm mới ngày nghỉ"}
                    handleClose={() => setOpenModalLuu(false)}
                    handleSave={() => submitLuu(data)}>
                    Bạn có muốn {!themMoi ? "cập nhật ngày nghỉ" : "tạo mới ngày nghỉ"} không?
                </ModalTextForm>
            }
            <section className="content" style={{ paddingBottom: "47px" }}>
                <Row>
                    <Col span={24}>
                        <Form layout="vertical" onFinish={onFinish} validateMessages={validateMessages} form={form}>
                            <Tabs defaultActiveKey="1" items={[
                                {
                                    key: '1',
                                    label: 'Thông tin chung',
                                    children:
                                        <div className="card pt-3 pb-2">
                                            <div className="tab-content pl-3 pr-3">
                                                <Row gutter={16}>
                                                    <Col span={8}>
                                                        <Form.Item name="tuNgay" label="Từ Ngày" rules={[{ required: true }]} >
                                                            <DatePicker changeOnBlur={true} style={{ width: "100%" }} placeholder="Từ ngày" format={["DD/MM/YYYY", "DDMMYYYY"]} onChange={disableDenNgay} locale={viVN} />
                                                        </Form.Item>

                                                    </Col>
                                                    <Col span={8} >
                                                        <Form.Item name="denNgay" label="Đến ngày" rules={[{ required: true }]} >
                                                            <DatePicker changeOnBlur={true} disabledDate={disableDenNgay} style={{ width: "100%" }} placeholder="Đến Ngày" format={["DD/MM/YYYY", "DDMMYYYY"]} onChange={disableDenNgay} locale={viVN} />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={8}>
                                                        <Col span={24}>
                                                            <Form.Item name="idLoaiNgayNghi" label="Loại ngày nghỉ" rules={[{ required: true }]}>
                                                                <LoaiNgayNghiSelectBox onChange={() => { }} />
                                                            </Form.Item>
                                                        </Col>
                                                    </Col>
                                                </Row>
                                                <Row gutter={16}> {/*
                                                    <Col span={8}>
                                                        <Form.Item name="heSo" label="Hệ số">
                                                            <Input placeholder="Hệ số" />
                                                        </Form.Item>
                                                    </Col>*/}
                                                    <Col span={8}>
                                                        <Form.Item name="isLapHangNam" label=" "  valuePropName="checked">
                                                            <Checkbox onChange={(e) => setIsLapHangNam(e.target.checked)}>Lặp hằng năm</Checkbox>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={16}>
                                                        <Form.Item name="lyDo" label="Lý do">
                                                            <TextArea rows={2} placeholder="Lý do" />
                                                        </Form.Item>
                                                    </Col>
                                                </Row> 
                                                <Form.Item style={{ marginBottom: "0px" }}>
                                                    <Button style={{ position: "fixed", zIndex: 1, right: "24px", bottom: "70px" }} type="primary" className="float-right" htmlType="submit" icon=<SaveOutlined rev="" />>
                                                        Lưu
                                                    </Button>
                                                    {data.id > 0 && (
                                                        <Button onClick={() => setOpenModalXoa(true)} style={{ position: "fixed", zIndex: 1, right: "120px", bottom: "70px" }} type="primary" danger className="hrm-btn-delete" icon=<SaveOutlined rev=""  />>
                                                            Xóa
                                                        </Button>
                                                    )}
                                                </Form.Item>
                                            </div>
                                        </div>
                                },
                            ]}>
                            </Tabs>
                        </Form>
                    </Col>
                </Row>
            </section>

        </>
    )
}

export default ChiTietNgayLe;